import React, { useState } from "react";

import helpers, { sendMessageToApp } from "../../../../utils/helpers";
import { pdfLegals } from "../../../../model/pdfLegal";
import {
  RideButton,
  RideGlDownloadSolid,
  RideGlDown,
  RideGlUp,
} from "@rimac-seguros/ride-system-components";

import "./styles.scss";
import { useSelector } from "react-redux";
import { encryptAES256 } from "@/utils/cifrate";
import { APP_KEY_ENCRYPT } from "@/utils/awsConfig";

const PdfLegal = () => {
  const [moreInformation, setMoreInformation] = useState(false);

  const { isEmbedded } = useSelector((state) => state.embeddedReducer);

  const handleMoreInformation = () => {
    setMoreInformation((moreInformation) => !moreInformation);
  };

  const handleClickPDFLegal = (text, link) => () => {
    helpers.getTagAction(
      "Consulta SOAT",
      "Información legal de tu SOAT",
      "Click",
      text,
      "trackAction"
    );
    handleClickPDF(link);
  };

  const filterLegals = moreInformation
    ? pdfLegals
    : pdfLegals.filter((item) => !item.hideMobile);

  const leftColumnLegals = pdfLegals.filter((item, index) => index % 2 === 0);
  const rightColumnLegals = pdfLegals.filter((item, index) => index % 2 !== 0);

  const filterLegalsLeft = moreInformation
    ? leftColumnLegals
    : leftColumnLegals.filter((item) => !item.hideDesktop);
  const filterLegalsRight = moreInformation
    ? rightColumnLegals
    : rightColumnLegals.filter((item) => !item.hideDesktop);

  const handleClickPDF = (link) => {
    if (isEmbedded) {
      const message = `EMBEDDED-APP-HIPERVINCULO : {"accion": "PDF", "valor": "${link}", "mensaje": ""}`;
      const encryptedMessage = encryptAES256(message, APP_KEY_ENCRYPT);
      return sendMessageToApp(encryptedMessage);
    }
    window.open(link, "_blank", "noopener noreferrer");
  };

  return (
    <div id="rbr-section-pdplegal" className="pdplegal-container">
      <p className="pdplegal-title">Información legal de tu SOAT</p>
      <div className="options-container">
        {filterLegals.map((item, index) => (
          <a key={index} onClick={handleClickPDFLegal(item.name, item.url)}>
            <RideButton
              text={item.name}
              variant="text-secondary"
              glyph={
                <RideGlDownloadSolid size="small" className="options-icon" />
              }
              glyphPosition="left"
              size="large"
              className="text-left"
            />
          </a>
        ))}
      </div>
      <div className="options-container-desktop">
        {filterLegalsLeft.map((item, index) => (
          <a key={index} onClick={handleClickPDFLegal(item.name, item.url)}>
            <RideButton
              text={item.name}
              variant="text-secondary"
              glyph={
                <RideGlDownloadSolid size="small" className="options-icon" />
              }
              glyphPosition="left"
              size="large"
              className="text-left"
            />
          </a>
        ))}
      </div>
      <div className="options-container-desktop">
        {filterLegalsRight.map((item, index) => (
          <a key={index} onClick={handleClickPDFLegal(item.name, item.url)}>
            <RideButton
              text={item.name}
              variant="text-secondary"
              glyph={
                <RideGlDownloadSolid size="small" className="options-icon" />
              }
              glyphPosition="left"
              size="large"
              className="text-left"
            />
          </a>
        ))}
      </div>
      <div className="button-container">
        {!moreInformation ? (
          <RideButton
            text="Ver más información"
            variant="text-primary"
            glyph={<RideGlDown size="small" />}
            glyphPosition="right"
            size="large"
            onClick={handleMoreInformation}
          />
        ) : (
          <RideButton
            text="Ver menos información"
            variant="text-primary"
            glyph={<RideGlUp size="small" />}
            glyphPosition="right"
            size="large"
            onClick={handleMoreInformation}
          />
        )}
      </div>
    </div>
  );
};

export default PdfLegal;
